import { render, staticRenderFns } from "./ContactAgent.vue?vue&type=template&id=553d80e8&lang=pug"
import script from "./ContactAgent.vue?vue&type=script&lang=js"
export * from "./ContactAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports